<template>
  <iRow gap="small" wrap="nowrap" vertical-align="bottom">
    <iColumn width="hug">
      <iTextInput
        v-model="landingUrl"
        name="landingUrl"
        placeholder="Product URL"
        label="Product URL"
        :required="false"
        type="text"
        @enter="submit"
      />
    </iColumn>
    <iButton
      type="submit"
      :disabled="loadingCreateAffiliateLink || !landingUrl"
      :is-loading="loadingCreateAffiliateLink"
      loading-text="This might take a minute"
      @click="submit"
    >
      Create Link
    </iButton>
  </iRow>
  <template v-if="affiliateLinkError">
    <iText variant="subtle">
      {{ affiliateLinkError }}
    </iText>
  </template>
  <iColumn
    v-if="createdAffiliateLink.short_link"
    gap="small"
  >
    <iSubHeading font-size="standard">
      Your personal monetization link
    </iSubHeading>
    <iCopyText
      :text="createdAffiliateLink.short_link"
      copy-message="Link Copied!"
      message-position="right"
      class="link-copy"
    />
  </iColumn>

  <iColumn
    v-if="createdAffiliateLink.short_link"
    :max-width="500"
  >
    <iSubHeading> Keep your links organized </iSubHeading>

    <iColumn>
      <iSubHeading font-size="large">
        Add meta data
      </iSubHeading>
      <iColumn gap="small">
        <iTextEditInput
          v-model="linkTitle"
          label="Link Title"
          width="fill"
          display-actions-as-block
          editable-on-click
          placeholder="Enter Link Title"
          @submit="saveProductName"
        />
        <iTextEditInput
          v-model="linkDescription"
          label="Link Description"
          width="fill"
          display-actions-as-block
          editable-on-click
          placeholder="Enter Link Description"
          @submit="saveLinkDescription"
        />
      </iColumn>
    </iColumn>

    <iColumn>
      <iSubHeading> Add to collections </iSubHeading>
      <SelectAffiliateCollection :short-link-id="formattedLinkId" />
    </iColumn>
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useAffiliateLinkStore } from "%/stores/affiliate-link-store";
import SelectAffiliateCollection from "@/components/SelectAffiliateCollection.vue";

export default {
  name: "LinkGeneratorWidget",
  components: {
    SelectAffiliateCollection,
  },
  props: {},
  data() {
    return {
      landingUrl: "",
      linkTitle: "",
      linkDescription: "",
    };
  },
  computed: {
    ...mapState(useAffiliateLinkStore, [
      "createdAffiliateLink",
      "affiliateLinkError",
      "loadingCreateAffiliateLink",
      "orgId",
    ]),
    formattedLinkId() {
      return this.createdAffiliateLink &&
        this.createdAffiliateLink.short_link_id
        ? Number(this.createdAffiliateLink.short_link_id)
        : 0;
    },
  },
  methods: {
    ...mapActions(useAffiliateLinkStore, [
      "createLink",
      "editShortLinkProductDetails",
    ]),
    submit() {
      if (!this.landingUrl) {
        return;
      }
      this.createLink(this.landingUrl);
    },
    saveProductName(value) {
      this.linkTitle = value;

      if (!this.createdAffiliateLink?.short_link_id) {
        return;
      }

      this.editShortLinkProductDetails(
        0,
        this.createdAffiliateLink.short_link_id,
        this.createdAffiliateLink.brand_name || "",
        value,
        this.createdAffiliateLink.my_product_description ||
          this.linkDescription,
        this.createdAffiliateLink.notes || "",
        0,
        this.createdAffiliateLink.my_advertiser_name ||
          this.createdAffiliateLink.advertiser_name ||
          "",
      );
    },
    saveLinkDescription(value) {
      this.linkDescription = value;

      if (!this.createdAffiliateLink?.short_link_id) {
        return;
      }

      this.editShortLinkProductDetails(
        0,
        this.createdAffiliateLink.short_link_id,
        this.createdAffiliateLink.brand_name || "",
        this.createdAffiliateLink.my_product_name || this.linkTitle,
        value,
        this.createdAffiliateLink.notes || "",
        0,
        this.createdAffiliateLink.my_advertiser_name ||
          this.createdAffiliateLink.advertiser_name ||
          "",
      );
    },
  },
};
</script>

<style scoped>
.link-copy :deep(.disabled-input) {
  background-color: transparent;
  border-color: var(--color-border);
}

.link-copy :deep(.input-container) {
  padding-right: 0.5rem;
}
</style>
